import React from "react";
import { getChurchByName, getChurchByPersonCreate } from "./axios.js";
import StorageKeys from "../../../Utility/StorageKey.js";
import StorageBox from "../../../Store/StorageBox.js";
import UserBaseUtils from "../../../Utility/UserBase.js";
import { Barhux } from "../../PostButtonComponent/PostButtonComponent";
import JoinButtonComponent from "../../JoinButtonComponent/JoinButtonComponent";
import CreateChurchForm from "./WidgetChurch/CreateChurch.tsx";
export class mainb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      introduction: "",
      imagesName: "",
      notification: null,
      showCompleteChurchModal: false,
      showChurchNotFoundModal: false,
      showCompleteChurchStep: null, // 'intro' | 'form'
    };
    this.GetprofileImage = this.GetprofileImage.bind(this);
    this.handleJoinResult = this.handleJoinResult.bind(this);
  }

  async componentDidMount() {
    // Get current user
    const currentUser = UserBaseUtils.getProfileUserName();
    console.log("mainB - Current user:", currentUser);

    if (currentUser && currentUser !== "Public/Anonymous") {
      // Get church by personCreate (current user)
      const { data, error } = await getChurchByPersonCreate(currentUser);
      console.log("mainB - Church data for personCreate:", data);
      console.log("mainB - Error:", error);

      if (!error && data) {
        console.log("mainB - Full church data:", data);
        console.log("mainB - userJoin from data:", data.userJoin);
        console.log("mainB - userJoin type:", typeof data.userJoin);
        console.log("mainB - userJoin isArray:", Array.isArray(data.userJoin));

        this.setState({
          name: data.name || "",
          introduction: data.introduction || "",
          imagesName: data.imagesName,
        });

        // Save church data to storage
        const churchDetailsToSave = {
          name: data.name,
          introduction: data.introduction,
          imagesName: data.imagesName,
          id: data.id,
          personCreate: data.personCreate,
          userJoin: data.userJoin || [],
        };

        console.log("mainB - Saving to storage:", churchDetailsToSave);
        StorageBox.inputChurchDetails(churchDetailsToSave);
        if (!data.introduction || data.introduction.trim() === "") {
          this.setState({
            showCompleteChurchModal: true,
            showCompleteChurchStep: "intro",
          });
        }
      } else {
        // Church not found for this user - set empty state
        this.setState({
          name: "",
          introduction: "",
          imagesName: null,
          showChurchNotFoundModal: false,
        });
      }
    } else {
      // No user logged in - use default/empty state
      this.setState({ name: "", introduction: "", imagesName: null });
    }
  }

  getCurrentSubdomain = () => {
    // Get the church name from URL path: /church/isacc
    const pathname = window.location.pathname;

    // Check if the path starts with /church/
    if (pathname.startsWith("/church/")) {
      // Extract the church name after /church/
      const churchName = pathname.split("/church/")[1]?.split("/")[0];
      if (churchName) {
        return churchName; // Returns "isacc"
      }
    }

    // Fallback: try subdomain for backwards compatibility
    const hostname = window.location.hostname;
    const parts = hostname.split(".");

    if (parts.length >= 3) {
      return parts[0]; // Returns subdomain
    }

    return null; // No church specified
  };

  GetprofileImage(user) {
    console.log("why is this unchanging");
    console.log(user);
    var item = StorageKeys.SupabaseChurchUrlProfile + user;
    return item;
  }

  handleJoinResult(result) {
    this.setState({ notification: result });

    // Auto-hide notification after 3 seconds
    setTimeout(() => {
      this.setState({ notification: null });
    }, 3000);
  }

  render() {
    const { showCompleteChurchModal, showChurchNotFoundModal } = this.state;
    return (
      <div className="grid">
        {showCompleteChurchModal && (
          <div className="bg-black/60 fixed inset-0 z-50 flex items-center justify-center">
            {this.state.showCompleteChurchStep === "intro" ? (
              <div className="mx-4 w-[500px] w-full max-w-xl rounded-xl bg-gray-800 p-6 shadow-2xl">
                <h3 className="mb-2 text-xl font-semibold">
                  Thanks for joining TanyaPendeta Online
                </h3>
                <p className="mb-6 text-gray-400">
                  There are some more information that we need in order to set
                  up your church.
                </p>
                <div className="flex justify-end">
                  <button
                    className="rounded bg-orange-400 px-4 py-2 text-white hover:bg-orange-500"
                    onClick={() =>
                      this.setState({ showCompleteChurchStep: "form" })
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <div
                className="relative mx-4 w-full max-w-2xl"
                onClick={(e) => e.stopPropagation()}
              >
                <CreateChurchForm
                  onClose={() =>
                    this.setState({
                      showCompleteChurchModal: false,
                      showCompleteChurchStep: null,
                    })
                  }
                  inputData={async () => {}}
                  churchName={this.state.name}
                />
              </div>
            )}
          </div>
        )}

        {/* Notification */}
        {this.state.notification && (
          <div
            className={`fixed right-4 top-4 z-50 rounded-lg p-4 shadow-lg transition-all duration-300 ${
              this.state.notification.success
                ? "bg-green-500 text-white"
                : "bg-red-500 text-white"
            }`}
          >
            <div className="flex items-center">
              <svg
                className="mr-2 h-5 w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                {this.state.notification.success ? (
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                ) : (
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                )}
              </svg>
              <span className="font-medium">
                {this.state.notification.message}
              </span>
            </div>
          </div>
        )}

        <div class="ml-2 flex w-full p-5 pl-2 pt-3 ">
          <div class="bg-slate-600 h-10 w-12 rounded-full p-2 pt-1.5">
            {this.state.imagesName != null && this.state.imagesName != "" ? (
              // TRUE CASE: Render the image
              <img
                src={this.GetprofileImage(this.state.imagesName)}
                alt="Image"
                className="mr-2 h-8 w-8 rounded-full"
              />
            ) : (
              <svg
                version="1.0"
                fill="orange"
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-6 text-orange-200"
                viewBox="0 0 264 308"
              >
                <path d="M83 42v23h156V22H83v21zm116 .5V176h40V65h-40v55.5zM83 107v28H27v41h56v103h37V176h62v-42h-62V79H83v28z"></path>
                <path d="M141 263.5V279h41v-41h-41v21.5z"></path>
              </svg>
            )}
          </div>
          <p class="ml-1 pl-0 pt-2.5 text-sm font-bold text-white">
            {this.state.name ? `c/${this.state.name}` : "TanyaPendeta Team"}{" "}
          </p>
        </div>
        {!this.state.name || this.state.name === "" ? (
          <div class="ml-2 p-5 pt-0">
            <p class="mb-4 text-sm font-medium text-gray-400">
              There is no church selected or created yet.
            </p>
            <p class="mb-4 text-sm font-medium text-gray-400">
              Please proceed to create church at
            </p>
            <button
              className="rounded bg-orange-600 px-4 py-2 text-sm font-medium text-white hover:bg-orange-700"
              onClick={() => {
                window.location.href = "/admin/church";
              }}
            >
              Create Church
            </button>
          </div>
        ) : (
          <p class="ml-2 whitespace-pre-wrap p-5 pt-0 text-sm font-medium text-gray-400">
            {this.state.introduction ||
              "Welcome to TanyaPendeta, we are here all this time, to listen and always understanding to the problem that you faced in daily life. Feel free to approach and talk to us regrading the few problem that you might be facing in life :)"}
          </p>
        )}
      </div>
    );
  }
}
